const config = {
  apiKey: "AIzaSyDPX3W2rKM-xXzRM1EALhb-LzKHI7l5Rdg",
  authDomain: "bypal-adffb.firebaseapp.com",
  databaseURL: "https://bypal-adffb.firebaseio.com",
  projectId: "bypal-adffb",
  storageBucket: "bypal-adffb.appspot.com",
  messagingSenderId: "951613448061"
};

module.exports = config;
